import { render, staticRenderFns } from "./OfertaSingle.vue?vue&type=template&id=c89f8fce&scoped=true&lang=pug"
import script from "./OfertaSingle.vue?vue&type=script&lang=js"
export * from "./OfertaSingle.vue?vue&type=script&lang=js"
import style0 from "./OfertaSingle.vue?vue&type=style&index=0&id=c89f8fce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c89f8fce",
  null
  
)

export default component.exports